import React, {useContext, useEffect} from 'react';
import {Grid} from '@material-ui/core';
import InputField from '../../../../FormikUtils/InputField'
import SelectField from '../../../../FormikUtils/SelectField'
import {Field, useFormikContext} from 'formik'
import FormikAutocomplete from '../../../../FormikUtils/FormikAutocomplete'
import withMultipleContexts from "../../../../../../context/utils/withMultipleContexts";
import MotovehiculoContextProvider
    from "../../../../../../context/products/MotovehiculoContext/MotovehiculoContextProvider";
import loadMotovehiculoData from "../../../../../../context/products/MotovehiculoContext/loadMotovehiculoData";
import MotovehiculoContext from "../../../../../../context/products/MotovehiculoContext/MotovehiculoContext";
import {findSelectedLabel} from "../../../../../utils/findSelectedLabel";

function MotovehiculoForm(props) {
    const {
        formField: {
            motovehiculo: {
                marca,
                anio,
                version,
                valorAdicional,
                ceroKm,
            }
        },
        vehicleDetails,
        cotizacionRetomada
    } = props;

    const {values, setFieldValue} = useFormikContext();

    const {
        marcas,
        anios,
        versiones,
        isLoadingVersions,
        updateVersions,
        handleRecotizarInitialValues
    } = useContext(MotovehiculoContext);

    const cerokm_options = [
        {value: 'true', label: 'Si'},
        {value: 'false', label: 'No'}
    ];

    useEffect(() => {
        if (cotizacionRetomada) {
            handleRecotizarInitialValues(values.motovehiculo.version, values.motovehiculo.detalle_version, values.motovehiculo.detalle_marca);
        }
    }, []);


    useEffect(() => {
        if (cotizacionRetomada) {
            updateVersions(values.motovehiculo.marca, values.motovehiculo.anio, false);
        } else {
            if (values.motovehiculo.anio !== '') {
                setFieldValue(version.name, '', false);
                updateVersions(values.motovehiculo.marca, values.motovehiculo.anio, true);
            }
        }
    }, [values.motovehiculo.anio, values.motovehiculo.marca]);

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Field
                        name={marca.name}
                        label={marca.label}
                        component={FormikAutocomplete}
                        options={marcas}
                        textFieldProps={{
                            label: marca.label,
                            required: true,
                        }}
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_marca: findSelectedLabel(marcas, value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <SelectField
                        name={anio.name}
                        label={anio.label}
                        data={anios}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        name={version.name}
                        label={version.label}
                        component={FormikAutocomplete}
                        options={versiones}
                        loading={isLoadingVersions}
                        textFieldProps={{
                            label: version.label,
                            required: true,
                        }}
                        onChangeAction={value => {
                            vehicleDetails.current = {
                                ...vehicleDetails.current,
                                detalle_version: findSelectedLabel(versiones, value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectField
                        name={ceroKm.name}
                        label={ceroKm.label}
                        data={cerokm_options}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField
                        name={valorAdicional.name}
                        label={valorAdicional.label}
                        fullWidth
                        textTransform={'capitalize'}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default withMultipleContexts(MotovehiculoForm, [
    {
        loadDataFunctions: [loadMotovehiculoData],
        ContextProvider: MotovehiculoContextProvider,
        dataKey: 'motovehiculoData',
        storageKey: 'motovehiculoData',
    }
])
